import * as React from 'react';
//@ts-ignore
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as QueryString from 'query-string';
import { AppContext, IAppContext } from './contexts/AppContext';
import ICertificate from './models/ICertificate';
import CertificationMeta from './util/CertificationMeta';
import { certMasterApiUrl } from './environment';
import { faIdCard, faCertificate } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { faXmark, faPrint } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import ICertificateTitleAndId from './models/ICertificateTitleAndId';
import Modal from './Modal';
import Loader from "react-loader-spinner";
import CertMetrics from './CertMetrics';

import './ManageCert.scss';
//@ts-ignore
import oblogo from './images/openbadge.png';
//@ts-ignore
import fblogo from './images/f_logo_RGB-Blue_144.png';
//@ts-ignore
import lilogo from './images/LI-In-Bug.png';


interface IManageCertProps {

}

interface IManageCertState {
    certificateId: string;
    certificate?: ICertificate;
    selectedCertificateId: string;
    examDescription?: string;
    examSkills?: Array<{ domain: string, objectives: Array<string> }>;
    showShareDialog: boolean;
    showCertificateDialog: boolean;
    showCertSelectorDialog: boolean;
    showVerifyDialog: boolean;
    certs?: Array<ICertificateTitleAndId>;
    verifyStatus?: Array<boolean | undefined>;
    notFound?: boolean;
    copiedText?: string;
    printingAllowed: boolean;
}

export default class ManageCert extends React.PureComponent<IManageCertProps, IManageCertState> {
    static contextType = AppContext;
    constructor(props: IManageCertProps) {
        super(props);
        const q = QueryString.parse((window.location.search ?? "").toUpperCase());
        let certId = q.CERTIFICATEID;
        if (certId == null) {
            let path = window.location.pathname.toString();
            if (path.endsWith("/"))
                path = path.substr(0, path.length - 1);
            let match = path.match(/\/(manage|verify)cert\/(.*)/i);
            if (match)
                certId = match[2];
        }
        let showCertSelector = window.location.pathname.match(/managecert/i) != null && (certId ?? "") === "";
        this.state = {
            certificateId: certId as string,
            selectedCertificateId: certId as string,
            showShareDialog: false,
            showCertificateDialog: false,
            showCertSelectorDialog: showCertSelector,
            showVerifyDialog: false,
            printingAllowed: new Date() < new Date("2025-06-01"),
        };
    }

    async componentDidMount() {
        if (this.state.showCertSelectorDialog)
            this.showCertSelector();
        else {
            const response = await fetch(`/api/certification/${this.state.certificateId}`);
            if (response.status === 200) {
                let cert = await response.json() as ICertificate;
                //@ts-ignore
                this.setState({ certificate: cert }, async () => {
                    if (cert.container) {
                        CertificationMeta.getExamDescription(cert.container).then((ed) => { this.setState({ examDescription: ed }) });
                        CertificationMeta.getExamSkills(cert.container).then((es) => { this.setState({ examSkills: es }) });
                    }
                });
            }
            else this.setState({ notFound: true });
        }
    }

    buildLinkedInShareHref() {
        if (this.state.certificate != null) {
            let verifyUrl = `${window.location.origin}/verifycert/${this.state.certificate.certificateId}`;
            let m = moment(this.state.certificate.certificateDate);
            return `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${this.state.certificate?.certificationTitle}&organizationId=16529&issueYear=${m.year()}&issueMonth=${m.month()}&certId=${this.state.certificate.certificateId}&certUrl=${encodeURIComponent(verifyUrl)}`;
        }
        return "";
    }

    buildOrderCertificateHref() {
        let context = this.context as IAppContext | undefined;
        if (context != null && context.user != null)
            return `https://shop${window.location.toString().indexOf('certificationdev') > -1 ? "test" : ""}.testout.com/Products.aspx?code=0-18-AC&version=6&user=${context.user.userProfileId}`;
        return "";
    }

    showCertSelector() {
        //@ts-ignore
        this.setState({ showCertSelectorDialog: true }, async () => {
            const response = await fetch(`/api/certification/certlist`);
            if (response.ok)
                this.setState({ certs: await response.json() as Array<ICertificateTitleAndId> })
        });
    }

    redirect(certId: string) {
        const queryParams = new URLSearchParams(window.location.search);
        const branch = queryParams.get('branch');

        window.location.assign(`${window.location.origin}/manageCert/${certId}${branch ? `?branch=${branch}` : ""}`);
    }

    renderVerification(status: boolean | undefined) {
        if (status == null) {
            //@ts-ignore
            return <span><Loader type="TailSpin" color="rgb(24, 128, 224)" height={20} width={20} /></span>;
        }
        if (status)
            return <span style={{ color: "green" }}><FontAwesomeIcon icon={faCheck as IconProp} /></span>;
        return <span style={{ color: "red" }}><FontAwesomeIcon icon={faXmark as IconProp} /></span>
    }

    _verifyCert: ICertificate | undefined = undefined;
    _verifyIndex: number = -1;
    _timeout: number = -1;
    doVerify() {
        this._verifyIndex = -1;
        let verify = [] as Array<boolean>;
        //@ts-ignore
        this.setState({ showVerifyDialog: true, verifyStatus: verify }, async () => {
            const response = await fetch(`/api/certification/${this.state.certificateId}`);
            if (response.ok)
                this._verifyCert = await response.json() as ICertificate;
            else this._verifyCert = undefined;
            this._timeout = setTimeout(() => { this.doVerifyStep(); }, 1000) as any;
        });
    }

    doVerifyStep() {
        if (this.state.verifyStatus == null)
            return;

        let verify = this.state.verifyStatus.slice();
        this._verifyIndex++;
        if (this._verifyIndex < 7) {
            let newState: boolean | undefined = undefined;
            if (this.state.certificate != null && this._verifyCert != null) {
                switch (this._verifyIndex) {
                    case 0:
                        newState = this._verifyCert.certificateDate === this.state.certificate.certificateDate;
                        break;
                    case 1:
                        newState = true;
                        break;
                    case 2:
                        newState = this._verifyCert.candidateName === this.state.certificate.candidateName;
                        break;
                    case 3:
                        newState = this._verifyCert.candidateId === this.state.certificate.candidateId;
                        break;
                    case 4:
                        newState = this._verifyCert.certificateId === this.state.certificate.certificateId;
                        break;
                    case 5:
                        newState = true;
                        break;
                    case 6:
                        newState = verify[0] && verify[2] && verify[3] && verify[4];
                        break;
                }
            }
            else newState = false;

            if (newState != null) {
                verify[this._verifyIndex] = newState;
                this.setState({ verifyStatus: verify }, () => {
                    this._timeout = setTimeout(() => { this.doVerifyStep(); }, 750) as any;
                });
            }
        }
    }

    cancelVerify() {
        if (this._timeout > -1)
            clearTimeout(this._timeout);
        this._timeout = -1;
        this.setState({ showVerifyDialog: false });
    }

    handleImageError(e: React.SyntheticEvent<HTMLImageElement, Event>) {
        const target = e.target as HTMLImageElement;
        target.src = 'https://cdn.testout.com/certification-meta-v2/comptia_c_logo/badge.png';
    }

    //@ts-ignore
    async incrementFeature(feature: string) {
        await fetch(`/api/user/feature/${feature}`, { method: 'POST', headers: {'Content-Type': 'application/json'}});
    }

    buildDownloadCertHref() {
        if (this.state.certificate != null)
            return `/api/certification/download/${this.state.certificate.userProfileId}/${this.state.certificate.certificationId}`;

        return "";
    }

    render() {
        let context = this.context as IAppContext | undefined;
        let isSelf = context != null && context.user != null && context.user.userProfileId === this.state.certificate?.userProfileId;
        let allowManage = isSelf && (window.location.pathname.match(/managecert/i) != null);
        if ((this.state.certificateId ?? "") === "" && !this.state.showCertSelectorDialog)
            window.location.assign(`${window.location.origin}/lookupcert`);

        return (
            <>
                {this.state.notFound && <div className="manageCert">
                    <div className="certNotFound">
                        <h1>The certificate you were looking for could not be found.</h1>
                        {context != null && context.user != null && <div><a onClick={() => { this.showCertSelector() }} className="button">Other Certificates</a></div>}
                    </div>
                </div>}
                {this.state.certificate != null && <div className="manageCert">
                    <div>
                        {allowManage && <span>
                            <a className="button" onClick={() => { this.setState({ showShareDialog: true }) }}>Share</a>
                            <a className="button" onClick={() => { this.setState({ showCertificateDialog: true }) }}>Certificate</a>
                            <a className="button" onClick={() => { this.showCertSelector() }}>Other Certificates</a>
                        </span>}
                        {!allowManage && <span>
                            <a className="button" onClick={() => { this.doVerify() }}>Verify</a>
                        </span>}
                    </div>
                    <div>
                        <span>This certificate was issued to <span>{isSelf && allowManage ? "you" : this.state.certificate.candidateName}</span> on {moment(this.state.certificate.certificateDate).format('M/D/yyyy')} and doesn't have an expiration date.</span>
                    </div>
                    <div>
                        <div>
                            <img style={{ width: "192px" }} src={`https://cdn.testout.com/certification-meta-v2/${this.state.certificate.container}/badge.png`} onError={this.handleImageError} alt="Certificate Badge Logo" />
                            <div><span>Learner Id:</span>{this.state.certificate.candidateId}</div>
                            <div><span>Certificate Id:</span>{this.state.certificate.certificateId}</div>
                        </div>
                        <div>
                            <h1>{this.state.certificate.certificationTitle}</h1>
                            {this.state.examDescription != null && <p>{this.state.examDescription}</p>}
                            {this.state.examSkills != null && <>
                                <h2>Skills</h2>
                                <div className="skills">{this.state.examSkills.map((domain, idx) => {
                                    return <div key={idx}><span><span>{domain.domain}</span></span>{
                                        domain.objectives.map((objective, idx) => {
                                            return <span key={idx}><span>{objective}</span></span>;
                                        })
                                    }</div>
                                })}</div>
                            </>}
                        </div>
                    </div>
                </div>}
                {this.state.showShareDialog && <Modal>
                    <div className="dialog">
                            <div>
                                <div>
                                    <span>Share your Certificate</span>
                                <a className="chromeless" onClick={() => { this.setState({ showShareDialog: false }) }}><FontAwesomeIcon icon={faXmark as IconProp} /></a>
                                </div>
                            <div className="manageCert_ShareList">
                                <a target="_blank" href={this.buildLinkedInShareHref()} rel="noreferrer" download="Certificate.pdf" onClick={() => this.incrementFeature("ShareToLinkedIn")}>
                                    <div><img src={lilogo} alt="LinkedIn Logo" width="36px" height="36px" /></div>
                                    <div><span>LinkedIn</span><span>Share your certificate on LinkedIn. This will include a link that allows viewers to verify the certificate.</span></div>
                                </a>
                                <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${window.location.origin}/api/badge/facebookshare/${this.state.certificate?.userProfileId}/${this.state.certificateId}`)}`} rel="noreferrer">
                                    <div><img src={fblogo} alt="Facebook Logo" width="36px" height="36px" /></div>
                                    <div><span>Facebook</span><span>Share your certificate on Facebook. This will include a link that allows viewers to verify the certificate.</span></div>
                                </a>
                                <a target="_self" href={`${window.location.origin}/api/badge/badge/${this.state.certificateId}`}>
                                    <div style={{ fontSize: "36px" }}><FontAwesomeIcon icon={faIdCard as IconProp} /></div>
                                    <div><span>Digital Badge</span><span>Download your certificate as a digital badge, using the Open Badge Standard, for use on sites like Badgr.com.</span></div>
                                </a>

                                <CopyToClipboard text={`${window.location.origin}/verifycert/${this.state.certificateId}`}
                                    onCopy={() => this.setState({ showShareDialog: false, copiedText: `${window.location.origin}/verifycert/${this.state.certificateId}` })}>
                                    <a>
                                        <div><img src={oblogo} alt="Badge Logo" width="36px" height="41px" /></div>
                                        <div><span>Web Link</span><span>Copy a link to this certificate's verification page.</span></div>
                                    </a>
                                </CopyToClipboard>
                            </div>
                        </div>
                    </div>
                </Modal>}
                {this.state.showCertificateDialog && <Modal>
                    <div className="dialog">
                        <div>
                            <div>
                                <span>Get a certificate</span>
                                <a className="chromeless" onClick={() => { this.setState({ showCertificateDialog: false }) }}><FontAwesomeIcon icon={faXmark as IconProp} /></a>
                            </div>
                                <div className="manageCert_Certificates">
                                    <a target="_self" download rel="noreferrer" href={this.buildDownloadCertHref()} onClick={() => this.incrementFeature("DownloadCertAsPDF")}>
                                        <div><FontAwesomeIcon icon={faPrint as IconProp} /></div>
                                        <div><span>Download PDF Certificate</span><span>Download and print your own certificate at home.</span></div>
                                    </a>
                                {this.state.printingAllowed && (
                                    <>
                                        <a target="_blank" href={this.buildOrderCertificateHref()} rel="noreferrer" onClick={() => this.incrementFeature("OrderCert")}>
                                            <div><FontAwesomeIcon icon={faCertificate as IconProp} /></div>
                                            <div><span>Order a Certificate<span className="discontinuing-notice">{' '}*</span></span><span>Order a professionally printed certificate and wallet card.</span></div>
                                        </a>
                                        <span className="discontinuing-notice">Note, we will be discontinuing printed certificates as of June 1, 2025</span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>}
                {this.state.showCertSelectorDialog && <Modal>
                    <div className="dialog">
                        <div>
                            <div>
                                <span>Select a Certificate</span>
                                <a className="chromeless" onClick={() => { this.setState({ showCertSelectorDialog: false }) }}><FontAwesomeIcon icon={faXmark as IconProp} /></a>
                            </div>
                            <CertMetrics />
                            <div className="manageCert_CertList">
                                {this.state.certs != null && <>
                                    {this.state.certs.length === 0 && <span className="error"> Your TestOut account has no Certificates.</span>}
                                    {this.state.certs.map((ctid, idx) => {
                                        return <a className="chromeless" key={idx} onClick={() => { this.redirect(ctid.id) }}>
                                            <img src={`https://cdn.testout.com/certification-meta-v2/${ctid.container}/badge.png`} alt="Certificate Badge Logo" style={{ width: "32px" }} />{ctid.title}
                                        </a>;
                                    })}
                                    
                                </>}   
                            </div>
                        </div>
                    </div>
                </Modal>}
                {this.state.showVerifyDialog && <Modal>
                    <div className="dialog">
                        <div>
                            <div>
                                <span>Verification</span>
                                <a className="chromeless" onClick={() => { this.cancelVerify() }}><FontAwesomeIcon icon={faXmark as IconProp} /></a>
                            </div>
                            {this.state.certificate != null && this.state.verifyStatus != null && <div className="manageCert_Verification">
                                <div>{this.renderVerification(this.state.verifyStatus[0])}<span>{`Issued on ${moment(this.state.certificate.certificateDate).format('M/D/yyyy')}`}</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[1])}<span>{`Issued by CompTIA`}</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[2])}<span>{`Issued to ${this.state.certificate.candidateName}`}</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[3])}<span>{`Learner Id is ${this.state.certificate.candidateId}`}</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[4])}<span>{`Certificate Id is ${this.state.certificate.certificateId}`}</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[5])}<span>Never expires</span></div>
                                <div>{this.renderVerification(this.state.verifyStatus[6])}<span style={{fontWeight: 700}}>Verified</span></div>
                            </div>}
                        </div>
                    </div>
                </Modal>}

                {this.state.copiedText != null && <Modal>
                    <div className="dialog">
                    <div>
                        <div>
                            <span>Certification URL</span>
                                <a className="chromeless" onClick={() => { this.setState({ copiedText: undefined }) }}><FontAwesomeIcon icon={faXmark as IconProp} /></a>
                        </div>
                        <div className="manageCert_copiedTextMsg">
                            <p>
                                <span>URL copied to clipboard</span><br />
                                <span><a href={this.state.copiedText}>{this.state.copiedText}</a></span>
                            </p>
                            <p>
                                <a className="button solid" onClick={() => { this.setState({ copiedText: undefined }) }}>Close</a>
                            </p>
                        </div>
                        </div>
                    </div>
                </Modal>}
           </>
        );
    }
}